import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-mrr-down',
  templateUrl: './mrr-down.component.html',
  styleUrls: ['./mrr-down.component.scss']
})
export class MrrDownComponent implements OnInit {
  @Input() valor: number;
  @Input() porcentagem: number;
  @Input() fonte: string;
  constructor() { }

  ngOnInit(): void {
  }

}
